import { call, put, takeEvery } from "redux-saga/effects";
import { worldCupMatchesRequest } from "../../api/worldCupMatches";
import { worldCupMatchesActions } from "../../store/worldCupMatches/actions";
import { WORLD_CUP_MATCHES_REQUEST } from "../../constants/worldCupMatches";

function* worldCupMatchesRequestSaga(): any {
  try {
    const worldCupMatches = yield call(worldCupMatchesRequest);
    yield put(
      worldCupMatchesActions.worldCupMatchesSuccessAction(worldCupMatches)
    );
  } catch (e: any) {
    yield put(worldCupMatchesActions.worldCupMatchesFailureAction(e));
  }
}
function* worldCupMatchesSaga() {
  yield takeEvery(WORLD_CUP_MATCHES_REQUEST, worldCupMatchesRequestSaga);
}

export default worldCupMatchesSaga;
